import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjectWellM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.74129 3.97165C7.20748 2.67612 8.79252 2.67612 9.25871 3.97165L12.9649 14.2711C13.0615 14.5394 12.9519 14.8476 12.7202 14.9594C12.4884 15.0712 12.2223 14.9443 12.1258 14.676L11.8635 13.9471L4.13649 13.9471L3.87422 14.676C3.77767 14.9443 3.51155 15.0712 3.27983 14.9594C3.04811 14.8476 2.93853 14.5394 3.03508 14.2711L6.74129 3.97165ZM4.51527 12.8945L11.4847 12.8945L10.7271 10.7891L5.27283 10.7893L4.51527 12.8945ZM5.65161 9.73666H10.3484L9.59083 7.63142L6.40917 7.63142L5.65161 9.73666ZM6.78794 6.5788L9.21206 6.5788L8.41957 4.3765C8.26417 3.94466 7.73583 3.94466 7.58043 4.3765L6.78794 6.5788Z"
        fill="#97B2C4"
      />
      <path
        d="M9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2L7 14C7 14.5523 7.44772 15 8 15C8.55229 15 9 14.5523 9 14L9 2Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export const IconGeoObjectWell = createIcon({
  l: IconGeoObjectWellM,
  m: IconGeoObjectWellM,
  s: IconGeoObjectWellM,
  xs: IconGeoObjectWellM,
  name: 'IconGeoObjectWell',
})
